import { Navigate, Route, Routes } from 'react-router-dom';
import { Archive } from './routes/Archive';
import { BatchNotes } from './routes/BatchNotes';
import { Endorsements } from './routes/Endorsements';
import { IR } from './routes/IR';
import { Layout } from './routes/Layout';
import { Login } from './routes/Login';
import { NightlySweep } from './routes/NightlySweep';
import { People } from './routes/People';
import { PlayerFile } from './routes/PlayerFile';
import { Prospects } from './routes/Prospects';
import { Schedule } from './routes/Schedule';
import { StatIntel } from './routes/StatIntel';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/stat-intel" replace />} />
        <Route path="/stat-intel" element={<StatIntel />} />
        <Route path="/nightly-sweep" element={<NightlySweep />} />
        <Route path="/batch-notes" element={<BatchNotes />} />
        <Route path="/people" element={<People />} />
        <Route path="/people/:playerId" element={<PlayerFile />} />
        <Route path="/people/:playerId/injuries" element={<PlayerFile />} />
        <Route path="/clients" element={<Prospects tracker="client" />} />
        <Route path="/prospects" element={<Prospects />} />
        <Route path="/ir" element={<IR />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/endorsements" element={<Endorsements />} />
        <Route path="/schedule" element={<Schedule />} />
      </Route>
      <Route path="*" element={<Navigate to="/stat-intel" replace />} />
    </Routes>
  );
}
